import React from 'react'
import PropTypes from 'prop-types'

import { Statistic } from 'semantic-ui-react'

import { mapObject } from 'Global/Helpers/objectHelpers'
import { numberWithSeperator } from 'Global/Helpers/stringHelpers'

const Statistics = props => {
  const { statistics } = props

  const mappedStatistics = mapObject(statistics, (key, value) => {
    return (
      <Statistic key={key + value}>
        <Statistic.Value>{numberWithSeperator(value)}</Statistic.Value>

        <Statistic.Label>{key}</Statistic.Label>
      </Statistic>
    )
  })

  return <Statistic.Group widths={Object.keys(statistics).length}>{mappedStatistics}</Statistic.Group>
}

Statistics.propTypes = {
  statistics: PropTypes.object.isRequired,
}

export default Statistics
